import React from "react";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import SpecialLifeAtButton from "@common/LifeAtButton/Variants/SpecialLifeAtButton";
import LifeAtModal from "@common/LifeAtModal/LifeAtModal";
import { buildRoute } from "@util/RouteUtil";

const PAGE_TITLE = "Sorry, the page you were looking for was not found.";

export default function NotFoundPage() {
    return (
        <LifeAtModal title={PAGE_TITLE} isOpen closeModal={() => {}} preventClose centerContent>
            <SpecialLifeAtButton
                isLink
                link={buildRoute(Routes.App)}
                openInCurrTab
                text="Return to LifeAt"
                variant="blue"
            />
        </LifeAtModal>
    );
}
